import { Routes, Route } from "react-router-dom";
// import Login from "./pages/Login";
import AdminPageLayout from "./layout/AdminPageLayout";
import Home from "./pages/Home";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import AdminLogin from "./pages/loginPage";
import {
  CommuneShow,
  CommuneIndividual,
  CommuneIndividualEdit,
} from "./pages/commune";
// import {
//   InteractionShow,
//   InteractionIndividual,
//   InteractionIndividualEdit,
// } from "./pages/interaction";
import {
  WebsiteShow,
  WebsiteIndividual,
  WebsiteIndividualEdit,
  WebsiteCreate,
} from "./pages/website";
import {
  BlogIndividual,
  BlogShow,
  BlogIndividualEdit,
  CreateBlogPage,
} from "./pages/blogs";
import {
  NotificationIndividualEdit,
  NotificationShow,
  NotificationIndividual,
} from "./pages/notifications";
import {
  UserEdit,
  UserProfileIndividual,
  UserProfileShow,
  UserCreate,
} from "./pages/users";
Amplify.configure(awsconfig);

function App() {
  return (
    <>
      <Routes>
        <Route path="/adminLogin" element={<AdminLogin />} />
        <Route path="/" element={<AdminPageLayout />}>
          <Route index element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/blog" element={<BlogShow />} />
          <Route path="/blog/:blogId" element={<BlogIndividual />} />
          <Route path="/blog/:blogId/edit" element={<BlogIndividualEdit />} />
          <Route path="/blog/create" element={<CreateBlogPage />} />
          <Route path="/website" element={<WebsiteShow />} />
          <Route path="/website/:websiteId" element={<WebsiteIndividual />} />
          <Route path="/website/create" element={<WebsiteCreate />} />
          <Route
            path="/website/:websiteId/edit"
            element={<WebsiteIndividualEdit />}
          />
          <Route path="/commune" element={<CommuneShow />} />
          <Route path="/commune/:communeId" element={<CommuneIndividual />} />
          <Route
            path="/commune/:communeId/edit"
            element={<CommuneIndividualEdit />}
          />
          {/* <Route path="/interaction" element={<InteractionShow />} />
          <Route
            path="/interaction/:interactionId"
            element={<InteractionIndividual />}
          />
          <Route
            path="/interaction/:interactionId/edit"
            element={<InteractionIndividualEdit />}
          /> */}

          <Route path="/notifications" element={<NotificationShow />} />
          <Route
            path="/notifications/:notificationId"
            element={<NotificationIndividual />}
          />
          <Route
            path="/notifications/:notificationId/edit"
            element={<NotificationIndividualEdit />}
          />
          <Route path="/userprofiles" element={<UserProfileShow />} />
          <Route path="/userprofiles/create" element={<UserCreate />} />
          <Route
            path="/userprofiles/:userId"
            element={<UserProfileIndividual />}
          />
          <Route path="/userprofiles/:userId/edit" element={<UserEdit />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
